import type * as React from "react";
import { type ReactNode } from "react";
import { Accordion, AccordionDetails, AccordionSummary, styled } from "~/common/mui";
import { useTranslation } from "react-i18next";

interface FilterGroupItemProps {
  className?: string;
  initiallyExpanded?: boolean;
  title: string;
  "data-test-id"?: string;
  children?: ReactNode;
  hidden?: boolean;
}

const FilterGroupItem: React.FC<FilterGroupItemProps> = (props) => {
  const testId = props["data-test-id"] ? `filter-category-${props["data-test-id"]}` : undefined;
  const { t } = useTranslation();
  return (
    <StyledAccordion defaultExpanded={props.initiallyExpanded} hidden={props.hidden}>
      <AccordionSummary data-test-id={testId} sx={{ userSelect: "text" }}>
        {t(props.title)}
      </AccordionSummary>
      <AccordionDetails className={props.className}>{props.children}</AccordionDetails>
    </StyledAccordion>
  );
};

export default FilterGroupItem;

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  backgroundColor: theme.palette.surface.bright,
}));
